"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { PRODUCT_GRADIENTS } from "@jti/ui/components/FlavourCarousel/components/FlavourCarouselCard/FlavourCarouselCard";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const flavourCarouselCardInputs = [
  {
    name: "backgroundGradient",
    type: "string",
    enum: Object.keys(PRODUCT_GRADIENTS),
  },
  {
    name: "description",
    type: "richText",
    required: true,
    defaultValue:
      "A Minty Fruity flavour, with Mango taste and complex tropical fruit tonalities. The volatile mango flavor gives way to a fresh, cool mouth sensation.",
  },
  {
    name: "title",
    required: true,
    type: "string",
    defaultValue: "Amarillo",
  },
  {
    name: "image",
    type: "object",
    required: true,
    subFields: [
      {
        name: "src",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
      },
      {
        name: "alt",
        type: "string",
      },
    ],
    defaultValue: {
      src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F8ab4cce049ca4707baa17b5b5d0c95a6",
      alt: "Amarillo",
    },
  },
  {
    name: "theme",
    type: "string",
    required: true,
    defaultValue: "light",
    enum: ["light", "dark"],
  },
  {
    name: "cta",
    type: "object",
    subFields: [
      {
        name: "label",
        type: "string",
      },
      {
        name: "url",
        type: "string",
      },
      {
        name: "openIn",
        friendlyName: "Open in",
        type: "string",
        enum: ["new Tab", "same Tab"],
        onChange: `options.set("target", (options.get("openIn") === "new Tab"? "_blank" : "_self"))`,
      },
      {
        hideFromUI: true,
        name: "target",
        type: "string",
        defaultValue: "_self",
        enum: ["_blank", "_self"],
      },
    ],
    defaultValue: {
      label: "Shop Now",
      url: "/",
      target: "_self",
    },
  },
  {
    name: "flavours",
    type: "list",
    subFields: [
      {
        name: "label",
        type: "string",
        required: true,
      },
      {
        name: "rating",
        type: "string",
        // Ratings from 0 to 5 in 0.5 increments (11 values)
        enum: Array.from({ length: 11 }, (_, i) => i * 0.5).map((value) => value.toString()),
        required: true,
      },
    ],
  },
  {
    name: "backgroundColor",
    type: "color",
    defaultValue: "#DAAC17",
  },
] as const satisfies Inputs;

export const FlavourCarouselCardComponent: RegisteredComponent = {
  name: "FlavourCarouselCard",
  component: dynamic(async () =>
    withValidation(
      flavourCarouselCardInputs,
      (await import("./FlavourCarouselCard")).FlavourCarouselCard,
      "FlavourCarouselCard"
    )
  ),
  inputs: flavourCarouselCardInputs,
};
